module.exports = __webpack_public_path__ + "img/banner.b200cd64.png";